import React, {createRef} from 'react'

import HintPopover from "../hint-popover/hint-popover"

type Props = {
    className?  : string

    icon?       : string
    label?      : string

    enableHint? : boolean
}

export default class InfoPanelLabel extends React.Component<Props, any> {

    static defaultProps = {
        enableHint: false
    }

    private ref: any = createRef()

    constructor(props: Props) {
        super(props);

        this.state = {
            useHint: false
        }
    }

    componentDidMount() {
        this._checkHintUsage();
    }

    componentDidUpdate() {
        this._checkHintUsage();
    }

    _checkHintUsage = () => {
        const useHint = gd.utils.getTextExceedsNodeWidth(this.props.label, this.ref.current, 0, 12);

        if (this.state.useHint !== useHint) {
            this.setState({
                useHint: useHint
            })
        }
    }

    render() {
        return (
            <div ref={this.ref} className={Classes("ip-label", this.props.className)}>
                {this.props.icon && <div className={Classes('ui5-ico-13 m-r-8', this.props.icon)}/>}

                {this.props.label}

                {this.state.useHint &&
                    <HintPopover hint={this.props.label} multiline={true} showDelay={500}/>}
            </div>
        )
    }
}
